// Posts a lead to the server-side capture service (same-origin /api/leads).
// Fire-and-forget: it must never block or break the user's real action (opening
// WhatsApp, etc.). Cal.com bookings are NOT sent here - Cal.com handles those.
import { trackEvent } from "@/lib/analytics";

export type LeadPayload = {
  name?: string;
  phone?: string;
  business?: string;
  source: "booking" | "contact";
  message?: string;
  consent?: boolean;
  website?: string; // honeypot - leave empty
};

export function saveLead(payload: LeadPayload): void {
  try {
    trackEvent("lead_submit_attempted", { source: payload.source, has_business: Boolean(payload.business), has_message: Boolean(payload.message) });
    const body = JSON.stringify({ ...payload, page_url: typeof location !== "undefined" ? location.pathname : "" });
    const isLocalDev =
      typeof location !== "undefined" &&
      (location.hostname === "127.0.0.1" || location.hostname === "localhost") &&
      location.port !== "4787";
    const endpoint = isLocalDev ? "/api/leads" : "/api/leads";
    fetch(endpoint, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true, // still sent even if the page navigates away right after
    })
      .then((res) => trackEvent(res.ok ? "lead_submit_succeeded" : "lead_submit_failed", { source: payload.source, status: res.status }))
      .catch(() => trackEvent("lead_submit_failed", { source: payload.source, status: 0 }));
  } catch {
    /* never throw */
  }
}
